module.exports = __webpack_public_path__ + "assets/img/4_158.61069df5.jpg";